export default __webpack_public_path__ + "static/media/transfer_portfolio.0a7da13a.svg";